import {Stub} from "../feed/components";

const AboutPage = () => {
    return <Stub placeholder={'AboutPage'} />
}

export default AboutPage;
